import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"
import ReactPlayer from "react-player/lazy"
import * as styles from "./VideoCard.css"
import {
  Card,
} from "../ui"

export type VideoProps = {
  id: string
  blocktype: string
  url: string
}

export default function Video(props: VideoProps) {
  const [hasWindow, setHasWindow] = useState(false)

  useEffect(() => {
    if (typeof window !== "undefined") {
      setHasWindow(true);
    }
  }, [])

  return (
    <Card>
      <div className={styles.videoContainer}>
        {hasWindow && (
          <ReactPlayer
            className={styles.videoPlayer}
            url={props.url}
            width="100%"
            height="100%"
          />
        )}
      </div>
    </Card>
  )
}

export const query = graphql`
  fragment VideoContent on Video {
    desktopRight
    url
  }
`